<template>
  <div>
    <v-subheader class="overline mt-5">
      {{ $t("promotionImage") }}
    </v-subheader>
    <div class="pa-4 px-6">
      <v-card
        class="mb-2"
        color="rgba(0, 0, 0, 0.2)"
        style="max-width: 400px; max-height: 200px"
      >
        <div
          class="d-flex justify-center align-center"
          style="max-width: 400px; height: 200px;"
        >
          <div
            v-if="(!image && !loadingPreview) || !passSizeTest"
            class="text-center"
            style="width: 100%;"
          >
            <div>
              <v-icon size="100" color="rgba(255,255,255, 0.3)">
                mdi-image
              </v-icon>
            </div>
            <div>
              <span class="body-2">{{ $t("noImageLoaded") }}</span>
            </div>
          </div>
          <div v-if="loadingPreview">
            <v-skeleton-loader
              class="mx-auto"
              max-width="400"
              type="image"
            ></v-skeleton-loader>
          </div>
          <div v-else-if="image != null && passSizeTest" style="width: 100%;">
            <v-img
              v-if="image"
              :key="image"
              :src="image"
              max-width="400"
              max-height="200px"
              contain
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </div>
        </div>
      </v-card>

      <div v-if="isCreating">
        <p class="caption grey--text">
          {{ $t("recommendedImagiSizePromoImage") }}
        </p>
      </div>
      <!-- Buttons -->
      <div v-if="isCreating" style="max-width: 400px">
        <div>
          <div class="d-flex">
            <div style="width: 100%">
              <v-file-input
                dense
                outlined
                :label="$t('loadImage')"
                required
                :disabled="disableImageUpload"
                @click.prevent="loadImage"
              />
            </div>
            <input
              id="imgInput"
              class="pb-6"
              ref="image"
              type="file"
              required
              @change="onFileChange"
            />
          </div>
        </div>
        <div style="max-width: 400px" class="d-flex justify-space-around">
          <div
            :class="{
              'd-flex column': $vuetify.breakpoint.mobile,
            }"
            style="width: 100%"
          >
            <div
              :style="$vuetify.breakpoint.mobile ? 'width: 100%' : 'width: 60%'"
            >
              <v-btn
                class="info mb-4"
                :loading="loading"
                :disabled="
                  !image ||
                    fileNotAllowed ||
                    !passSizeTest ||
                    !!cachedImageKey ||
                    loading
                "
                :block="$vuetify.breakpoint.smAndDown"
                @click="addImage"
              >
                {{ $t("toConfirm") }}
              </v-btn>
            </div>
            <div
              :hidden="!image || !passSizeTest || fileNotAllowed"
              style="width: 100%"
            >
              <v-btn
                color="#D50000"
                :block="$vuetify.breakpoint.smAndDown"
                @click="deleteImage(cachedImageKey, image)"
              >
                {{ $t("deleteImage") }}
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AWS from "aws-sdk";

var bucketName = "sga-assets";
var bucketRegion = "sa-east-1";
var domain = localStorage.getItem("operator");
var creds = new AWS.Credentials({
  accessKeyId: "accessKeyId",
  secretAccessKey: "secretAccessKey",
});

AWS.config.update({
  region: bucketRegion,
  credentials: creds,
});

var s3 = new AWS.S3({
  apiVersion: "2006-03-01",
  params: { Bucket: bucketName },
});

const allowedMimes = ["image/jpeg", "image/png", "image/jpg", "image/webp"];
const MAX_IMAGE_SIZE = 1000000; // max. 1MB
const MAX_IMAGE_WIDTH = 1800;
const MAX_IMAGE_HEIGHT = 700;
// let MAX_IMAGES; // max. images input
// let images_qtd = "";

export default {
  name: "image-promo-upload",
  props: [
    "promoOrCampaignCode",
    "dialog",
    "valid",
    "promotionType",
    "productType",
    "isCreating",
  ],
  data: () => ({
    loading: false,
    image: null,
    imageLoaded: false,
    imageSelected: false,
    passSizeTest: false,
    fileNotAllowed: false,
    cachedImageKey: "",
    loadingPreview: false,
    promotionCode: "",
    param: "",
    url: "",
    order: 0,
    file: null,
    max_img_promo: "",
    // list Image
    imgList: [],
    // Delete Image
    imgModel: "",
    imageConfirmed: false,
  }),

  computed: {
    operatorId() {
      return this.$store.state.operator.operator_id;
    },
    disableImageUpload() {
      return !this.valid || typeof this.image === "string";
    },
  },

  mounted() {
    this.passSizeTest = false;
    this.isCreating ? this.reset() : this.setImage(this.promoOrCampaignCode);
  },

  watch: {
    dialog(val) {
      if (val) {
        if (this.isCreating) {
          this.reset();
        } else {
          this.setImage(this.promoOrCampaignCode);
        }
      }
    },

    file() {
      if (!this.file) {
        this.imageConfirmed = false;
      }
      // Tipos não permitidos
      if (!allowedMimes.includes(this.file.type)) {
        this.fileNotAllowed = true;
        this.loading = false;
        this.image = null;
        document.getElementById("imgInput").value = "";
        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("fileTypeNotAllowedImage"),
          color: "warning",
        });
      }
      if (this.file.type > MAX_IMAGE_SIZE) {
        this.fileNotAllowed = true;
        this.loading = false;
        this.image = null;
        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("imageTooLarge"),
          color: "warning",
        });
      }
    },
  },

  methods: {
    loadImage() {
      this.$refs.image.click();
    },

    // Input FILE
    onFileChange(element) {
      this.image = null;
      this.fileNotAllowed = false;
      this.passSizeTest = false;
      this.cachedImageKey = "";
      let files = element.target.files || element.dataTransfer.files;

      if (!files.length) {
        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("chooseAnImageFirst"),
          color: "warning",
        });
        return;
      }

      this.loadingPreview = true;
      // STORE FILE
      this.file = files[0];

      const _this = this;
      // Generate pre-view image UI
      let reader = new FileReader();
      reader.onload = (element) => {
        // validacao width x height da imagem
        let image = new Image();
        image.src = element.target.result;
        image.onload = function() {
          var height = this.height;
          var width = this.width;
          // MAX_IMAGE_WIDTH
          // MAX_IMAGE_HEIGHT
          if (height > MAX_IMAGE_HEIGHT || width > MAX_IMAGE_WIDTH) {
            _this.$store.commit("setFeedbackSnack", {
              msg: _this.$t("warningMaxSize"),
              color: "warning",
            });
            document.getElementById("imgInput").value = "";
            this.image = null;

            _this.passSizeTest = false;
            _this.imageSelected = false;
          } else if (!allowedMimes.includes(_this.file.type)) {
            _this.$store.commit("setFeedbackSnack", {
              msg: _this.$t("fileTypeNotAllowedImage"),
              color: "warning",
            });

            document.getElementById("imgInput").value = "";
            _this.passSizeTest = false;
            _this.imageSelected = false;
            _this.image = null;
          } else {
            _this.passSizeTest = true;
            _this.imageSelected = true;
            _this.image = element.target.result;
          }
        };
      };

      this.loadingPreview = false;
      reader.readAsDataURL(this.file);
    },

    // add Image
    addImage() {
      this.loading = true;
      if (!this.file || this.file == {}) {
        this.imageConfirmed = false;
      }
      // validacoes de tipo de arquivo e tamanho da imagem (MB) - Linha 755
      var ext;
      switch (this.file.type) {
        case "image/png":
          ext = ".png";
          break;
        case "image/jpeg":
        case "image/jpg":
          ext = ".jpg";
          break;
        default:
          ext = ".png";
          break;
      }
      // Verificação para promoções de token, promotionCode recebe domain + timeStamp como um id único
      let timeStamp = new Date().getTime();
      if (this.promotionType == "token") {
        this.promotionCode = domain.toUpperCase() + timeStamp;
      }

      if (
        this.promotionType == "1ºdeposito" ||
        this.promotionType == "deposito"
      ) {
        this.promotionCode = this.promoOrCampaignCode;
      } else if (
        this.productType == "casino" &&
        this.promotionType == "personalizado"
      ) {
        this.promotionCode = this.operatorId + timeStamp;

        this.$emit("campaignCodeImgCustom", this.promotionCode);
      }

      var domainImageKey = `domains/${domain}/promotions/`;
      var newImageKey = domainImageKey + this.promotionCode + ext;
      var upload = new AWS.S3.ManagedUpload({
        params: {
          Bucket: bucketName,
          Key: newImageKey,
          Body: this.file,
          ACL: "public-read",
        },
      });

      const _this = this;
      var promise = upload.promise();

      promise.then(
        function() {
          _this.$store.commit("setFeedbackSnack", {
            title: "Sucesso!",
            msg: _this.$t("loadImageSuccess"),
            color: "success",
          });
          _this.imageLoaded = false;
          _this.listImages("promotions");
          _this.cachedImageKey = newImageKey;
          _this.loading = false;
          _this.imageConfirmed = true;
          _this.$emit("isImageSent");
        },
        function(err) {
          _this.imageConfirmed = false;

          console.log(err);
        }
      );
    },

    // List Images
    listImages(param) {
      this.param = param;
      var carousel = {
        Prefix: `domains/${domain}/${param}/`,
      };
      const _this = this;
      var promise = s3.listObjects(carousel).promise();
      promise
        .then(function(data) {
          var href = "https://s3.sa-east-1.amazonaws.com/";
          var bucketUrl = href + bucketName + "/";
          var images = data.Contents.map(function(image) {
            var date = image.LastModified;
            var imageKey = image.Key;
            var imageUrl = bucketUrl + encodeURIComponent(imageKey);
            return { imageKey, imageUrl, date };
          });
          _this.imgList = images;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    deleteImage(imageKey, fileImage, showNotification = true) {
      this.imageConfirmed = false;

      if (imageKey) {
        // deleting Image from AWS s3
        const _this = this;
        s3.deleteObject({ Key: imageKey }, function(err) {
          if (err) {
            return alert(_this.$t("errorDeletingImage"), err.message);
          }
          if (showNotification) {
            _this.$store.commit("setFeedbackSnack", {
              msg: _this.$t("deletedImage"),
              color: "warning",
            });
          }
          _this.listImages("promotions");
        });
        document.getElementById("imgInput").value = "";
        this.cachedImageKey = "";
        this.image = null;
        this.imageLoaded = false;
        this.imageSelected = false;
        this.$emit("isImageSent");
      }
      if (fileImage) {
        // Deleting before upload to AWS
        if (!this.image) return;
        // reseta o <input>
        document.getElementById("imgInput").value = "";
        this.imageLoaded = false;
        this.fileNotAllowed = false;
        this.imageSelected = false;
        // reseta o v-img
        this.image = null;
      }
    },

    async setImage(code) {
      const promise = s3
        .listObjects({
          Prefix: `domains/${domain}/promotions/`,
        })
        .promise();

      const _this = this;

      await promise.then((data) => {
        data.Contents.forEach((image) => {
          const encodedImageKey = encodeURIComponent(image.Key);

          var s3BaseUrl = "https://s3.sa-east-1.amazonaws.com/";
          const imageUrl = `${s3BaseUrl}/${bucketName}/${encodedImageKey}`;

          const splittedByDot = imageUrl.split(".")[
            imageUrl.split(".").length - 2
          ];

          const imageName = splittedByDot.split("%2F")[
            splittedByDot.split("%2F").length - 1
          ];

          if (imageName === code) {
            this.passSizeTest = true;
            _this.image = imageUrl;
          }
        });
      });
    },

    reset() {
      this.cachedImageKey = "";
      this.image = null;
      this.passSizeTest = false;
      this.imageLoaded = false;
      this.loadingPreview = false;
      this.imageConfirmed = false;

      if (document.getElementById("imgInput")) {
        document.getElementById("imgInput").value = "";
      }
    },
  },
};
</script>

<style scoped>
input[type="file"] {
  display: none;
}
</style>
